import type { ReactNode } from 'react';

export const symbol_timer_5_shutter: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M591-200H370q-16.67 0-28.33-11.74Q330-223.47 330-240.24q0-16.76 11.67-28.26Q353.33-280 370-280h221v-160H370q-16.67 0-28.33-11.67Q330-463.33 330-480v-240q0-16.67 11.67-28.33Q353.33-760 370-760h261q16.67 0 28.33 11.74Q671-736.53 671-719.76q0 16.76-11.67 28.26Q647.67-680 631-680H410v160h181q33.33 0 56.67 23.33Q671-473.33 671-440v160q0 33.33-23.33 56.67Q624.33-200 591-200Z"
		/>
	</svg>
);
